export default __webpack_public_path__ + "static/Widianty Oey-5f7b5c17bff10578481ac04b653d816d.jpeg";